import { useNavigate } from 'react-router-dom'
import './index.scss'

interface ProfileItemProps {
  id: string
  name: string
  img?: string
  notification?: number
  isPaid?: boolean
  need_biography?: boolean
  isObituary?: boolean
  black?: boolean
  action?: () => void
}

const ProfileItem: React.FC<ProfileItemProps> = ({ id, name, img, black = false, notification, need_biography, isObituary = false, isPaid, action }) => {
  const navigate = useNavigate()
  return (
    <div className={`profile__item ${black && 'black'}`} onClick={action}>
      <div className="profile__item__img">
        {img
          ? <img src={img} alt={img} />
          : <div className='placeholder'><i className={`icon icon--${black ? 'add' : 'cross'}`}></i></div>}
      </div>
      <div className="profile__item__name">
        <span className='playfair'>{name}</span>
      </div>
      {isPaid && typeof notification === 'number' && notification > 0
        ? <div className="profile__item__notification">
          <div><i className="icon icon--notification s18"></i>{notification}</div>
        </div>
        : notification === -1
          ? <div className="profile__item__notification">
            <div>{isObituary ? 'Nekrolog' : 'Bez QR'}</div>
          </div>
          : !isPaid && isPaid !== undefined
            ? <div className="profile__item__notification error">
              <div>Do opłacenia</div>
            </div>
            : (need_biography && !isObituary)
              ? <div
                className="profile__item__notification"
                onClick={e => {
                  e.stopPropagation()
                  navigate(`/addprofile/${id}/update`, { state: { view: 'addWithQrView' } })
                }}>
                <div>Dodaj biografie</div>
              </div>
              : undefined
      }
    </div>
  )
}

export default ProfileItem